<template>
  <div class="ih-page-result ih-page">
    <h3 class="text-center" v-html="message"></h3>
  </div>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      message: ""
    };
  },

  computed: {},
  watch: {},
  methods: {},

  created() {},
  mounted() {
    this.message = this.$route.query.message;
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/pages/Result";
</style>
